import { Directive, DirectiveBinding } from 'vue';

interface ClickOutsideElement extends HTMLElement {
	clickOutsideEvent: (event: Event) => void;
}

type ClickOutsideDirective = Directive<ClickOutsideElement, () => void>;

const clickOutside: ClickOutsideDirective = {
	beforeMount: (el: ClickOutsideElement, binding: DirectiveBinding) => {
		el.clickOutsideEvent = (event) => {
			// Check if click is outside the el and its children
			if (!(el === event.target || el.contains(event.target as HTMLElement))) {
				// if it is, run the method that was passed on
				binding.value();
			}
		};
		document.addEventListener('click', el.clickOutsideEvent);
	},
	unmounted: (el: ClickOutsideElement) => {
		document.removeEventListener('click', el.clickOutsideEvent);
	},
};

export default clickOutside;
